<template>
  <div ref="rootElement">
    <button
      ref="dropdownButton"
      type="button"
      class="flex items-center rounded-full border px-4 py-2.5 text-button-m transition-colors hover:bg-background-soft-active focus:bg-background-soft-active active:bg-background-inverted-hover"
      :class="{
        'bg-background-inverted-hover': isOpen || props.hasActiveFilter,
        'bg-background': !isOpen,
        'border-transparent': !props.hasActiveFilter,
      }"
      @click="toggleDropdown"
    >
      <slot />
      <Icon class="size-5" name="chevron-down" />
    </button>
    <div
      v-show="isOpen"
      class="absolute mt-1 min-w-60 overflow-auto rounded-3xl bg-background px-6 py-4 shadow-01"
      :style="{
        maxHeight: dropdownMaxHeight,
      }"
    >
      <slot name="content" />
    </div>
  </div>
</template>

<script setup lang="ts">
import Icon from '~/components/icon/Icon.vue'

const isOpen = ref(false)

const rootElement = useTemplateRef('rootElement')
const dropdownButton = useTemplateRef('dropdownButton')
const dropdownMaxHeight = ref('100vh')

const props = withDefaults(defineProps<{ hasActiveFilter?: boolean }>(), { hasActiveFilter: false })

const toggleDropdown = async () => {
  // Recalculate available size before opening
  if (!isOpen.value) {
    adjustDropdownMaxHeight()
    await nextTick()
  }

  isOpen.value = !isOpen.value
}

const closeDropdown = () => {
  isOpen.value = false
}

const adjustDropdownMaxHeight = () => {
  if (!isOpen.value) {
    return
  }

  if (dropdownButton.value && rootElement.value) {
    const MARGIN = 4 // mt-1
    const windowHeight = window.innerHeight
    const distanceFromWindowTop = dropdownButton.value.getBoundingClientRect().bottom + MARGIN

    dropdownMaxHeight.value = `${Math.max(200, windowHeight - distanceFromWindowTop - 40)}px`
  }
}

onMounted(() => {
  onClickOutside(rootElement, closeDropdown)
  useEventListener(window, ['scroll', 'resize'], useThrottleFrame(adjustDropdownMaxHeight), { passive: true })
})
</script>
